import { Trans } from 'react-i18next';

import {
    Anchor,
    Body1,
    Box,
    IconHelp,
    Modal,
    Stack,
    TextButton,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

interface UnsureCoverageLinkModalProps {
    linkText: string;
    modalHeading: string;
    modalBody: string;
    modalLinkUrl?: string;
    testIdPrefix: string;
}

export const UnsureCoverageLinkModal = ({
    linkText,
    modalHeading,
    modalBody,
    modalLinkUrl,
    testIdPrefix,
}: UnsureCoverageLinkModalProps) => {
    const [isOpen, { toggle }] = useDisclosure();

    return (
        <>
            <Box>
                <TextButton
                    LeftIcon={IconHelp}
                    onClick={toggle}
                    data-testid={`${testIdPrefix}-unsure-coverage-link`}
                >
                    {linkText}
                </TextButton>
            </Box>
            <Modal
                opened={isOpen}
                onClose={toggle}
                title={modalHeading}
                data-testid={`${testIdPrefix}-unsure-coverage-modal`}
            >
                <Stack gap="xs">
                    <Body1>
                        <Trans
                            ns="dynamic"
                            defaults={modalBody}
                            components={{
                                b: <strong />,
                                br: <br />,
                                a: (
                                    <Anchor
                                        href={modalLinkUrl ?? '#'}
                                        target="_blank"
                                    />
                                ),
                            }}
                        />
                    </Body1>
                </Stack>
            </Modal>
        </>
    );
};
